export default {
  state: {
    details: {},
    step: "Email",
    modalStatus: false,
  },

  getters: {
    getPasswordDetails: (state) => state.details,
    getPasswordStep: (state) => state.step,
    getPasswordModalStatus: (state) => state.modalStatus,
  },

  mutations: {
    setPasswordDetails(state, data) {
      state.details = Object.assign(state.details, data);
    },

    setPasswordStep(state, step) {
      state.step = step;
    },

    setDefaultPasswordConfig(state) {
      state.details = {};
      state.step = "Email";
      state.modalStatus = false;
    },

    setPasswordModalStatus(state, status) {
      state.modalStatus = status;
    },
  },

  actions: {
    changePasswordDetails(context, data) {
      context.commit("setPasswordDetails", data);
    },

    changePasswordStep(context, step) {
      context.commit("setPasswordStep", step);
    },

    changeForDefaultPasswordConfig(context) {
      context.commit("setDefaultPasswordConfig");
    },

    changePasswordModalStatus(context, status) {
      context.commit("setPasswordModalStatus", status);
    },
  },
};
